import React, { useState } from "react";
import icon1 from "../../assets/institution/icon1.svg";
import icon2 from "../../assets/institution/icon2.svg";
import icon3 from "../../assets/institution/icon3.svg";
import icon4 from "../../assets/institution/icon4.svg";
import icon5 from "../../assets/institution/icon5.svg";
import icon6 from "../../assets/institution/icon6.svg";
import SectionsTitle from "../Components/SectionsTitle";

const servicesData = [
  {
    Image: icon1,
    title: "Provide global visibility",
  },
  {
    Image: icon2,
    title: "Access to student base from all over the globe",

    iconColor: "#e9bf06",
  },
  {
    Image: icon3,
    title: "Access to highly advanced tools and technology",

    iconColor: "#3fcdc7",
  },
  {
    Image: icon4,
    title: "Maintain transparency",

    iconColor: "#41cf2e",
  },
  {
    Image: icon5,
    title: "Support to address your concerns",

    iconColor: "#d6ff22",
  },
  {
    Image: icon6,
    title: "Provide insights",

    iconColor: "#4680ff",
  },
];

export default function Main() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const imageStyles = servicesData.map((_, index) => ({
    width: hoveredIndex === index ? "140px" : "130px",
    transform: hoveredIndex === index ? "rotateY(180deg)" : "rotateY(0)",
    transition: "width 0.3s ease, transform 0.4s ease",
  }));

  return (
    <>
      <section id="" className="py-5 m-4">
        <div>
          <SectionsTitle title={"We are here for you"} />

          <div className="row mt-5">
            {servicesData.map((service, index) => (
              <div className="col-lg-4 col-md-6 text-center p-4 aos-init aos-animate" data-aos="zoom-out" key={index}>
                <div
                  className="border rounded-4 shadow"
                  style={{ height: "220px" }}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <img src={service.Image} className="img-fluid p-3" alt="icons" style={imageStyles[index]} />
                  <div className="mt-3 px-5">
                    <div className="text2 text-dark">{service.title}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
